module.exports = __webpack_public_path__ + "icon_cross_black.d4c29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_cross_black.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_cross_black.svg
// module chunks = main